module.exports = __webpack_public_path__ + "static/media/3-3-trnim-korunovan.2f0d5f7a.jpg";